import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchResource } from '@app/src/api/fetchHooks'
import type { Option } from '@app/src/pages/ResourceCollection/Filters/FilterSelect'
import NegatableSelect from '@app/src/pages/ResourceCollection/Filters/NegatableSelect'
import useNegatableFilter from '@app/src/pages/ResourceCollection/Filters/useNegatableFilter'
import type { CategoryOption, CategoryWithId } from '@app/src/types/categories'
import React from 'react'

interface NegatableCategoryFilterProps {
  category: CategoryWithId
  filterName: string
}

const NegatableCategoryFilter = ({ category, filterName }: NegatableCategoryFilterProps): JSX.Element => {
  const { positiveValues, negativeValues, updateFilters, toggleOptionNegation } = useNegatableFilter(
    filterName,
    category.id.toString(),
  )

  const { data: categoryOptions } = useFetchResource<CategoryOption[]>({
    key: [FetchKey.CategoryOption, category.id],
    endpoint: endpoints.categoryOptionsByCategory(category.id),
    options: { enabled: !category.options },
  })

  const optionsToDisplay = category.options ?? categoryOptions
  const options: Option[] = optionsToDisplay?.map(co => ({ label: co.name, value: co.id })) ?? []

  return (
    <NegatableSelect
      options={options}
      label={category.name}
      positiveValues={positiveValues}
      negativeValues={negativeValues}
      onUpdate={updateFilters}
      onToggleNegation={toggleOptionNegation}
    />
  )
}

export default NegatableCategoryFilter
